import { Component, Input, Output, EventEmitter, DoCheck, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { BehaviorSubject } from 'rxjs';
import { KngFilterPanelFactory } from './kng-filter-panel.factory';
import { CalendarFilter, Control, ControlType, Cta, CtaClickEvent, DateFilter, dateFilterLabels, DateRange, KngFilter, KngFilterState, Section, TermLabel } from './definitions/kng-filter-panel.interface';
import { Address } from '../../shared/shared.interface';
import { MatCheckbox } from '@angular/material/checkbox';
import { isRaymond } from '../../constants/environment.constant';
@Component({
	selector: 'kng-filter-panel',
	templateUrl: './template/kng-filter-panel.component.html',
	styleUrls: ['./template/kng-filter-panel.component.scss']
})
export class KngFilterPanelComponent implements KngFilter, DoCheck, OnInit
{
	isRaymond:boolean = false;
	private state$: BehaviorSubject<KngFilterState> =
		new BehaviorSubject<KngFilterState>(KngFilterPanelFactory.buildState());
	showToFromInput: boolean = false;
	othersInput: boolean = false;
	currentDate: Date = new Date();
	maxToDate = this.currentDate;
	fromDate!: Date;
	othersMonthValue: string = '0';
	toDate!: Date;
	toDateError: boolean = false;
	fromDateError: boolean = false;
	selectedOptions: string = '';
	isFilterLoad: boolean = false;
	collapsedIconRaymond:string = 'assets/images/accordion_collapsed_raymond.svg';
	expandedIconRaymond:string = 'assets/images/accordion_expanded_raymond.svg';
	calendarConstants = CalendarFilter;
	minToDate!: Date;
	minFromDate!: Date;
	maxFromDate!: Date;


@Input() set state(value: KngFilterState)
	{
		this.state$.next(value);
	}

get state(): KngFilterState
{
	return this.state$.value;
}

@Output() filterApplied: EventEmitter<CtaClickEvent> =
	new EventEmitter<CtaClickEvent>();
@Output() stateChanged: EventEmitter<void> = new EventEmitter<void>();
@Output() getCountOfFilterPanel: EventEmitter<Section> =
	new EventEmitter<Section>();
@Output() checkboxClickEvent: EventEmitter<Section> =
	new EventEmitter<Section>();

@Output() closeFilterEvent: EventEmitter<void> = new EventEmitter<void>();

constructor()
{
	this.setDefaultToFromDate();
}

ngOnInit(): void
{
	this.isRaymond = isRaymond || false;
}

setDefaultToFromDate(isNext: boolean = false): void

{
	this.toDateError = false;
	this.fromDateError = false;
	if(isNext)
	{
		this.fromDate = this.currentDate;
		this.toDate = this.currentDate;
		this.minToDate = this.currentDate;
		this.minFromDate = this.currentDate;
		return;
	}
	this.toDate = this.currentDate;
	this.fromDate = new Date(
		new Date().setDate(this.currentDate.getDate() - 60)
	);
}

ngDoCheck(): void 
{
	this.stateChanged.emit();
	if(isRaymond && this.state.filterData.sections.length)
	{
		this.state.filterData.sections.forEach((section) => 
		{
			if(dateFilterLabels.includes(section.label))
			{
				section.controls[0].options = section.controls[0].options.filter((option) => option.label !== DateFilter.customDateRange);
			}
		});
	}

}

buttonClicked(event: CtaClickEvent)
{
	const btnIndex = event.state.filterData.ctaList.findIndex(
		(cta: Cta) => cta.label === event.buttonClicked.label
	);
	if (btnIndex === 0)
	{
		this.showToFromInput = false;
		this.othersInput = false;
	}
	else
	{
		this.setToFromDate();
		this.setTermOtherValue();
	}
	this.filterApplied.emit(event);
}

checkboxClicked(section: Section)
{
	this.getCountOfFilterPanel.emit(section);
	this.checkboxClickEvent.emit(section);
}


setToFromDate()
{
	const section = this.state.filterData.sections;
	section.forEach((sec) =>
	{
		if(sec.controls[0]?.type === ControlType.radio)
		{
			const options = sec.controls[0].options;
			const index = options.findIndex((opt) => opt.label === DateRange.custom);
			if (index >= 0)
			{
				options[index].value =
                    this.fromDate.toString() + '@' + this.toDate.toString();
			}
		}
	});

}

setTermOtherValue()
{
	const section = this.state.filterData.sections;
	section.forEach((sec) =>
	{
		if(sec.controls[0]?.type === ControlType.notDate)
		{
			const options = sec.controls[0].options;
			const index = options.findIndex((opt) => opt.label === TermLabel.other);
			if (index >= 0) 
			{
				options[index].value = this.othersMonthValue;
			}
		}
	});
}

public updateState(value: KngFilterState) 
{
	this.state$.next(value);
}

public initializeFilterCount()
{
	this.isFilterLoad = true;
}

closeFilter()
{
	this.state.hidden = true;
	this.closeFilterEvent.emit();
}

clearSearch(control: Control)
{
	control.setValue('');
}

checkSelectedValue(indexctrl: number, indexsec: number)
{
	this.selectedOptions = '';
	const selectedFilterData =
        this.state.filterData.sections[indexsec].controls[0].options;
	selectedFilterData.forEach((opt) => (opt.checked = false));
	if (indexctrl >= 0)
	{
		selectedFilterData[indexctrl].checked = true;
		this.state.filterData.sections[indexsec].selectedValue = [(selectedFilterData[indexctrl].label)];
		const optionLabel = selectedFilterData[indexctrl].label;
		this.checkForNextFilter(selectedFilterData[indexctrl].description);
		if (optionLabel === DateRange.custom) 
		{
			this.selectedOptions = DateRange.custom;
			this.showToFromInput = true;
			if (this.fromDateError || this.toDateError)
			{
				this.state.filterData.ctaList[1].disabled = true;
			}
			else
			{
				this.selectedOptions = TermLabel.other;
				this.state.filterData.ctaList[1].disabled = false;
			}
		} 
		else if (optionLabel === TermLabel.other)
		{
			this.othersInput = true;
		}
		else
		{
			this.showToFromInput = false;
			this.othersInput = false;
			this.state.filterData.ctaList[1].disabled = false;
			this.state.filterData.ctaList[0].disabled = false;
		}
		this.updateState(this.state);
	}
}

checkForNextFilter(description: string | undefined)
{
	this.maxFromDate = this.currentDate;
	if(description && description === this.calendarConstants.next)
	{
		const customToMax = new Date(this.currentDate);
		customToMax.setFullYear(this.currentDate.getFullYear() + 5);
		this.maxToDate = customToMax;
		this.maxFromDate = customToMax;
	}
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any	
onKeyUp(event: any) 
{
	this.setDefaultToFromDate();
	if(event.target.id === 'fromDateInput' )
	{
		(<HTMLInputElement>document.getElementById('fromDateInput')).readOnly = true;
	}
	else if(event.target.id === 'toDateInput')
	{
		this.toDate = new Date();
		(<HTMLInputElement>document.getElementById('toDateInput')).readOnly = true;
	}
}

checkDateValidator(event: MatDatepickerInputEvent<Date>)
{
	let toDateUnix = this.toDate.getTime();
	let fromDateUnix = this.fromDate.getTime();
	if (event.targetElement.id === 'fromDateInput' && event.value)
	{
		this.fromDate = event.value;
		fromDateUnix = this.fromDate.getTime();
	}
	else if (event.targetElement.id === 'toDateInput' && event.value)
	{
		this.toDate = event.value;
		toDateUnix = this.toDate.getTime();
	}
	this.showError(event.targetElement.id, fromDateUnix, toDateUnix);
}

showError(id: string, fromDateUnix: number, toDateUnix: number)
{
	if (toDateUnix < fromDateUnix)
	{
		if (id === 'toDateInput')
		{
			this.toDateError = true;
			this.fromDateError = false;
			this.state.filterData.ctaList[1].disabled = true;
		}
		else if (id === 'fromDateInput')
		{
			this.fromDateError = true;
			this.toDateError = false;
			this.state.filterData.ctaList[1].disabled = true;
		}
	}
	else
	{
		this.toDateError = false;
		this.fromDateError = false;
		this.state.filterData.ctaList[1].disabled = false;
	}
}

formatAddress(address: Address)
{
	return [ address.addressLine1, address.addressLine2, address.city, address.state, address.zipCode ].filter(Boolean).join(', ');
}

displayRecordsHandler(section: Section, index:number)
{
	if(section.isShowMorePresent)
	{
		if(section.showMoreShowLess?.isShowMoreClicked)
		{
			return true;
		}
		else if(!section.showMoreShowLess?.isShowMoreClicked && index > 4)
		{
			return this.handleViewOnLoad(section, index);
		}
		return true;
	}
	return true;
}
isSearchFieldPresent(section: Section, index:number)
{
	return section.controls[0].type === ControlType.input && index < 6;
}
handleViewOnLoad(section: Section, index:number)
{
	if(this.isSearchFieldPresent(section, index))
	{
		return true;
	}
	return false;
}
handleDynamicDisplayOfShowMoreShowLess(btnClicked: string, section: Section)
{
	if(btnClicked === section.showMoreShowLess?.showMoreText)
	{
		section.showMoreShowLess.isShowMoreClicked = true;
	}
	else if( btnClicked === section.showMoreShowLess?.showLessText)
	{
		section.showMoreShowLess.isShowMoreClicked = false;
	}
}
isShowMorePresent(section: Section)
{
 	return ((section.controls.length > 6 && section.controls[0].type === ControlType.input) || (section.controls.length > 5 && section.controls[0].type !== ControlType.input)) && section.isShowMorePresent;
}
noResultsFound(sectioncontrol: Section)
{
	return  sectioncontrol.controls.length > 0 && sectioncontrol.controls[0].type === ControlType.input && (typeof sectioncontrol.controls[0].value === 'string' && sectioncontrol.controls[0].value.trimLeft().length > 2) && sectioncontrol.controls.length === 1 && !this.isError(sectioncontrol);
}
isErrorMessage(sectioncontrol: Section)
{
	return  sectioncontrol.controls.length > 0 && sectioncontrol.controls[0].type === ControlType.input && (typeof sectioncontrol.controls[0].value === 'string' && sectioncontrol.controls[0].value.trimLeft().length > 2) && sectioncontrol.controls.length === 1 && this.isError(sectioncontrol);
}
isError(sectioncontrol: Section)
{
	return sectioncontrol.noResultsFoundText && sectioncontrol.errorMessage && sectioncontrol.isAPIError;
}
isShowMoreDisabled(section: Section)
{
	return section.controls.every(control=>control.type === ControlType.checkbox && control.value === false && control.disabled);
}
isSectionWithSearchInput(expanded: boolean, section: Section)
{
	return (section.controls.some(control=>control.type === ControlType.input && control.isHidden !== true) && expanded)? 'sectionWithSearchControl' : '';
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
updateCheckedStateForAccessibility($event: any, checkbox: MatCheckbox)
{
	if($event)
	{
		checkbox.checked = true;
	}
}
}
